export const checkRole = (roles, groups = []) => {
  // const role = roles[0];
  //   const groups = [
  //     "SuperAdmin",
  //     "Marketing",
  //     "Analyze",
  //     "AnalyzeApprove",
  //     "CustomerService",
  //     "Debt",
  //   ];
  return roles?.some((role) => groups.includes(role));
  // return groups.includes(role);
};
